import { getProductSupplierInventoryReceipt } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

const useSWRProductSupplierInventoryReceipt = (supplierInventoryReceiptId: string | null) => {
  const {
    data: supplierInventoryReceipt,
    isLoading,
    error,
    mutate,
  } = useSWR(supplierInventoryReceiptId ? `productSupplierInventoryReceipt-${supplierInventoryReceiptId}` : null, () =>
    getProductSupplierInventoryReceipt(supplierInventoryReceiptId as string)
  );

  return {
    supplierInventoryReceipt,
    isLoading,
    error,
    refresh: () => mutate(),
  };
};

export default useSWRProductSupplierInventoryReceipt;
